import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipelineFiltersCacheService } from './pipeline-filters-cache.service';
import { PipelineFilterSaverService } from './pipeline-filter-saver.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [PipelineFiltersCacheService, PipelineFilterSaverService],
})
export class PipelineFiltersCacheModule {}
